<template>
    <router-link :to="homeURL" id="logo">
        <img class="bg" src="@/assets/img/ui/logo-bg.svg">
        <img class="logo" src="@/assets/img/ui/logo-arla.png">
        <span>Time to Impact</span>
    </router-link>
</template>
<script>
export default {
    computed: {
        homeURL() {
            return app.api.PageManager.getRootPage().route
        }
    }
}
</script>
<style lang="scss" scoped>
    #logo {


        position: absolute;
        width: 287px;
        top: 10px;
        right: 50px;
        z-index: 2;
        cursor: pointer;
        display: flex;
        justify-content: center;
        
        &>img.bg {
            width: 100%;
            opacity: 0.85;
            transform: translateY(-0.2px);
        }
  
        &>img.logo {
            width: 80px;
            position: absolute;
        }

        &>span {
            color:#fff;
            position: absolute;
            font-family: "Arla Strong";
            font-size: 15px;
            top:58px;
        }

    }
</style>